// test657
(657 && 0);
